import { appGeneratePath } from '@/shared/lib';

/** Шаблон адреса карточки экземпляра в разделе наполнения модели знаний */
export const KM_ENTITY_ROUTE_PATH = '/entities/:id?' as const;

/** Адрес экземпляра модели знаний в разделе её наполнения */
export const buildKmEntityPath = (entityId?: number): string =>
  appGeneratePath(KM_ENTITY_ROUTE_PATH, { id: entityId == null ? null : String(entityId) });
